const data: {
  [key: string]: {
    [key: string]: {
      modalTitle: string;
      name: string;
      options: Array<{ value: number; label: string; downLoadUrl: string }>;
    };
  };
} = {
  inTimeCheck: {
    // 主题活动价格校验场景
    10: {
      modalTitle: '添加白名单',
      name: '白名单',
      options: [
        {
          value: 1,
          label: 'SKU ID',
          downLoadUrl:
            '//storage.360buyimg.com/test.tag.pool.white/模版/%E6%A8%A1%E7%89%88_%E5%AE%9A%E6%97%B6%E6%A0%A1%E9%AA%8C%E7%99%BD%E5%90%8D%E5%8D%95-skuid.xlsx',
        },
        {
          value: 3,
          label: '类目 ID',
          downLoadUrl:
            '//storage.360buyimg.com/test.tag.pool.white/模版/%E6%A8%A1%E7%89%88_%E5%AE%9A%E6%97%B6%E6%A0%A1%E9%AA%8C%E7%99%BD%E5%90%8D%E5%8D%95-%E7%B1%BB%E7%9B%AEid.xlsx',
        },
        // {
        //   value: 2,
        //   label: '店铺 ID',
        //   downLoadUrl:
        //     '//storage.360buyimg.com/test.tag.pool.white/模版/%E6%A8%A1%E7%89%88_%E5%AE%9A%E6%97%B6%E6%A0%A1%E9%AA%8C%E7%99%BD%E5%90%8D%E5%8D%95-%E5%BA%97%E9%93%BAid.xlsx',
        // },
        {
          value: 8,
          label: '商家ID',
          downLoadUrl:
            '//storage.360buyimg.com/test.tag.pool.white/模版/%E6%A8%A1%E7%89%881_%E5%AE%9A%E6%97%B6%E6%A0%A1%E9%AA%8C%E7%99%BD%E5%90%8D%E5%8D%95-%E5%95%86%E5%AE%B6id.xlsx',
        },
      ],
    },
    22: {
      modalTitle: '剔除白名单',
      name: '剔除白名单',
      options: [
        {
          value: 1,
          label: 'SKU ID',
          downLoadUrl:
            '//storage.360buyimg.com/test.tag.pool.white/模版/%E6%A8%A1%E7%89%881_%E5%AE%9A%E6%97%B6%E6%A0%A1%E9%AA%8C%E5%89%94%E9%99%A4%E7%99%BD%E5%90%8D%E5%8D%95-skuid.xlsx',
        },
        {
          value: 3,
          label: '类目 ID',
          downLoadUrl:
            '//storage.360buyimg.com/test.tag.pool.white/模版/%E6%A8%A1%E7%89%881_%E5%AE%9A%E6%97%B6%E6%A0%A1%E9%AA%8C%E5%89%94%E9%99%A4%E7%99%BD%E5%90%8D%E5%8D%95-%E7%B1%BB%E7%9B%AEid.xlsx',
        },
        // {
        //   value: 2,
        //   label: '店铺 ID',
        //   downLoadUrl:
        //     '//storage.360buyimg.com/test.tag.pool.white/模版/%E6%A8%A1%E7%89%88_%E5%AE%9A%E6%97%B6%E6%A0%A1%E9%AA%8C%E7%99%BD%E5%90%8D%E5%8D%95-%E5%BA%97%E9%93%BAid.xlsx',
        // },
        {
          value: 8,
          label: '商家ID',
          downLoadUrl:
            '//storage.360buyimg.com/test.tag.pool.white/模版/%E6%A8%A1%E7%89%881_%E5%AE%9A%E6%97%B6%E6%A0%A1%E9%AA%8C%E5%89%94%E9%99%A4%E7%99%BD%E5%90%8D%E5%8D%95-%E5%95%86%E5%AE%B6id.xlsx',
        },
      ],
    },
  },
  zcInTimeCheck: {
    // 综促活动价格校验场景
    10: {
      modalTitle: '添加白名单',
      name: '白名单',
      options: [
        {
          value: 1,
          label: 'SKU ID',
          downLoadUrl:
            '//storage.360buyimg.com/test.tag.pool.white/模版/%E6%A8%A1%E7%89%88_%E5%AE%9A%E6%97%B6%E6%A0%A1%E9%AA%8C%E7%99%BD%E5%90%8D%E5%8D%95-skuid.xlsx',
        },
        {
          value: 3,
          label: '类目 ID',
          downLoadUrl:
            '//storage.360buyimg.com/test.tag.pool.white/模版/%E6%A8%A1%E7%89%88_%E5%AE%9A%E6%97%B6%E6%A0%A1%E9%AA%8C%E7%99%BD%E5%90%8D%E5%8D%95-%E7%B1%BB%E7%9B%AEid.xlsx',
        },
        // {
        //   value: 2,
        //   label: '店铺 ID',
        //   downLoadUrl:
        //     '//storage.360buyimg.com/test.tag.pool.white/模版/%E6%A8%A1%E7%89%88_%E5%AE%9A%E6%97%B6%E6%A0%A1%E9%AA%8C%E7%99%BD%E5%90%8D%E5%8D%95-%E5%BA%97%E9%93%BAid.xlsx',
        // },
        {
          value: 8,
          label: '商家ID',
          downLoadUrl:
            '//storage.360buyimg.com/test.tag.pool.white/模版/%E6%A8%A1%E7%89%881_%E5%AE%9A%E6%97%B6%E6%A0%A1%E9%AA%8C%E7%99%BD%E5%90%8D%E5%8D%95-%E5%95%86%E5%AE%B6id.xlsx',
        },
      ],
    },
    22: {
      modalTitle: '剔除白名单',
      name: '剔除白名单',
      options: [
        {
          value: 1,
          label: 'SKU ID',
          downLoadUrl:
            '//storage.360buyimg.com/test.tag.pool.white/模版/%E6%A8%A1%E7%89%881_%E5%AE%9A%E6%97%B6%E6%A0%A1%E9%AA%8C%E5%89%94%E9%99%A4%E7%99%BD%E5%90%8D%E5%8D%95-skuid.xlsx',
        },
        {
          value: 3,
          label: '类目 ID',
          downLoadUrl:
            '//storage.360buyimg.com/test.tag.pool.white/模版/%E6%A8%A1%E7%89%881_%E5%AE%9A%E6%97%B6%E6%A0%A1%E9%AA%8C%E5%89%94%E9%99%A4%E7%99%BD%E5%90%8D%E5%8D%95-%E7%B1%BB%E7%9B%AEid.xlsx',
        },
        // {
        //   value: 2,
        //   label: '店铺 ID',
        //   downLoadUrl:
        //     '//storage.360buyimg.com/test.tag.pool.white/模版/%E6%A8%A1%E7%89%88_%E5%AE%9A%E6%97%B6%E6%A0%A1%E9%AA%8C%E7%99%BD%E5%90%8D%E5%8D%95-%E5%BA%97%E9%93%BAid.xlsx',
        // },
        {
          value: 8,
          label: '商家ID',
          downLoadUrl:
            '//storage.360buyimg.com/test.tag.pool.white/模版/%E6%A8%A1%E7%89%881_%E5%AE%9A%E6%97%B6%E6%A0%A1%E9%AA%8C%E5%89%94%E9%99%A4%E7%99%BD%E5%90%8D%E5%8D%95-%E5%95%86%E5%AE%B6id.xlsx',
        },
      ],
    },
  },
};

export default data;
